module.exports = __webpack_public_path__ + "img/film-maker.974640d8.svg";